// Warm the LogJob route chunk so the first open is instant — no splash while
// the JS downloads. The dynamic import resolves to the SAME module (and chunk)
// as App.js's `lazy(() => import('../../pages/LogJob'))`, so webpack dedups:
// once prefetched, React's lazy() resolves immediately on navigation.
//
// Memoized — the import promise is created once and shared. Safe to call
// repeatedly (board mount, card hover, picker open); only the first call hits
// the network.
import { prefetchJobDetailChunk } from './prefetchJobDetail';

let chunkPromise = null;

export function prefetchLogJobChunk() {
  if (!chunkPromise) {
    chunkPromise = import('../../pages/LogJob').catch((err) => {
      // Reset so a transient failure can be retried on the next call.
      chunkPromise = null;
      throw err;
    });
  }
  return chunkPromise;
}

// Mount-time helper for the route boards: warm the chunk during idle time so it
// never competes with the board's own first paint / data fetch. Returns a
// cleanup that cancels the pending schedule. requestIdleCallback isn't on all
// Safari versions — fall back to a short timer.
// Log Job + job detail are the two screens a tap opens from every dashboard;
// both are warmed at the same idle point (KAN-1021). Failures are swallowed.
function warmJobEntryChunks() {
  Promise.resolve(prefetchLogJobChunk()).catch(() => {});
  prefetchJobDetailChunk();
}

export function schedulePrefetchLogJobChunk() {
  if (typeof window === 'undefined') return () => {};
  const ric = window.requestIdleCallback;
  if (ric) {
    const id = ric(() => warmJobEntryChunks());
    return () => window.cancelIdleCallback?.(id);
  }
  const id = window.setTimeout(() => warmJobEntryChunks(), 1200);
  return () => window.clearTimeout(id);
}
